import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=63559674&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63559674')) {
      api.createRecord('63559674', component.options)
    } else {
      api.reload('63559674', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=63559674&", function () {
      api.rerender('63559674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jcP8DZ4yl6zm/JS/comp/stardisplay.vue"
export default component.exports